import { buildElementId } from '../utils';

import { ValidateNumeric, ValidateRegExp, ValidateSelector } from './ElementValidators';

const dataFormater = (newErrors) => ({
  add: newErrors.add.filter(Boolean),
  remove: newErrors.remove.filter(Boolean),
});

const getValue = (answer) => {
  return (answer || { value: '' }).value;
};

const date = new Date();
let year = date.getFullYear() + 1;

const buildMessage = (caption, questions, getMessage, currentQuestion, labelKey, errorKey) => {
  if (!getMessage) return '';

  return `${caption} : ${
    questions[currentQuestion]?.question || getMessage(labelKey)
  } - ${getMessage(errorKey)}`;
};

const makeValubleTypeMusical = (
  newErrors,
  id,
  questions,
  validateAll,
  questionID,
  caption,
  getMessage
) => {
  newErrors = ValidateNumeric(
    getValue(questions.FirstYearOfServiceInstrument),
    buildElementId(id, 'VALUABLE_FIRSTYEAROFSERVICEINSTRUMENT'),
    newErrors,
    validateAll,
    1900,
    year,
    questionID,
    '^([1-9][0-9]{0,3})$',
    getMessage
      ? `${caption} : ${
          questions.FirstYearOfServiceInstrument?.question ||
          getMessage('labelText.FirstYearOfService')
        } - ${getMessage('error.fill.in.missing.information')}`
      : ''
  );

  // value Instrument
  newErrors = ValidateNumeric(
    getValue(questions.valueInstrument),
    buildElementId(id, 'VALUABLE_VALUEINSTRUMENT'),
    newErrors,
    validateAll,
    1,
    999999,
    questionID,
    '^[1-9]\\d*(?:\\.\\d{1,2})?$',
    getMessage
      ? `${caption} : ${
          questions.valueInstrument?.question ||
          getMessage('labelText.valueInstrument')
        } - ${getMessage('error.fill.in.missing.information')}`
      : ''
  );
  return dataFormater(newErrors);
};

const makeValubleTypeCamera = (
  newErrors,
  id,
  questions,
  validateAll,
  questionID,
  caption,
  getMessage
) => {
  newErrors = ValidateNumeric(
    getValue(questions.FirstYearOfServiceCamera),
    buildElementId(id, 'VALUABLE_FIRSTYEAROFSERVICECAMERA'),
    newErrors,
    validateAll,
    1900,
    year,
    questionID,
    '^([1-9][0-9]{0,3})$',
    getMessage
      ? `${caption} : ${
          questions.FirstYearOfServiceCamera?.question ||
          getMessage('labelText.FirstYearOfService')
        } - ${getMessage('error.fill.in.missing.information')}`
      : ''
  );

  // value Camera
  newErrors = ValidateNumeric(
    getValue(questions.valueCamera),
    buildElementId(id, 'VALUABLE_VALUECAMERA'),
    newErrors,
    validateAll,
    1,
    999999,
    questionID,
    '^[1-9]\\d*(?:\\.\\d{1,2})?$',
    getMessage
      ? `${caption} : ${
          questions.valueCamera?.question ||
          getMessage('labelText.valueCamera')
        } - ${getMessage('error.fill.in.missing.information')}`
      : ''
  );
  return dataFormater(newErrors);
};

const makeValubleTypeLens = (
  newErrors,
  id,
  questions,
  validateAll,
  questionID,
  caption,
  getMessage
) => {
  newErrors = ValidateNumeric(
    getValue(questions.FirstYearOfServiceLens),
    buildElementId(id, 'VALUABLE_FIRSTYEAROFSERVICELENS'),
    newErrors,
    validateAll,
    1900,
    year,
    questionID,
    '^([1-9][0-9]{0,3})$',
    getMessage
      ? `${caption} : ${
          questions.FirstYearOfServiceLens?.question ||
          getMessage('labelText.FirstYearOfService')
        } - ${getMessage('error.fill.in.missing.information')}`
      : ''
  );

  // value Lens
  newErrors = ValidateNumeric(
    getValue(questions.valueLens),
    buildElementId(id, 'VALUABLE_VALUELENS'),
    newErrors,
    validateAll,
    1,
    999999,
    questionID,
    '^[1-9]\\d*(?:\\.\\d{1,2})?$',
    getMessage
      ? `${caption} : ${
          questions.valueLens?.question ||
          getMessage('labelText.valueLens')
        } - ${getMessage('error.fill.in.missing.information')}`
      : ''
  );
  return dataFormater(newErrors);
};

const makeValubleTypeWeapon = (
  newErrors,
  id,
  questions,
  validateAll,
  questionID,
  caption,
  getMessage
) => {
  //First YearOf Service Weapon
  newErrors = ValidateNumeric(
    getValue(questions.FirstYearOfServiceWeapon),
    buildElementId(id, 'VALUABLE_FIRSTYEAROFSERVICEWEAPON'),
    newErrors,
    validateAll,
    1900,
    year,
    questionID,
    '^([1-9][0-9]{0,3})$',
    getMessage
      ? `${caption} : ${
          questions.FirstYearOfServiceWeapon?.question ||
          getMessage('labelText.FirstYearOfService')
        } - ${getMessage('error.fill.in.missing.information')}`
      : ''
  );

  // value Weapon
  newErrors = ValidateNumeric(
    getValue(questions.valueWeapon),
    buildElementId(id, 'VALUABLE_VALUEWEAPON'),
    newErrors,
    validateAll,
    1,
    999999,
    questionID,
    '^[1-9]\\d*(?:\\.\\d{1,2})?$',
    getMessage
      ? `${caption} : ${
          questions.valueWeapon?.question ||
          getMessage('labelText.valueWeapon')
        } - ${getMessage('error.fill.in.missing.information')}`
      : ''
  );
  return dataFormater(newErrors);
};

const makeValubleTypeWatch = (
  newErrors,
  id,
  questions,
  validateAll,
  questionID,
  caption,
  getMessage
) => {
  //Serial number
  newErrors = ValidateRegExp({
    value: getValue(questions.valuableSerialNumber),
    id: buildElementId(id, 'VALUABLE_SERIAL_NUMBER'),
    newErrors,
    validateAll,
    length: 1,
    questionID,
    regExp:
      '^([0-9a-zA-Z\u00C0-\u017F]+([ |-][0-9a-zA-Z\u00C0-\u017F]+)*|)$',
    maxLimit: 100,
    isOptional: true,
    errorLabel: buildMessage(caption, questions, getMessage, 'valuableSerialNumber', 'labelText.serialNumber', 'error.fill.in.missing.information')
  });
  //FirstYear Of Service Watch
  newErrors = ValidateNumeric(
    getValue(questions.FirstYearOfServiceWatch),
    buildElementId(id, 'VALUABLE_FIRSTYEAROFSERVICEWATCH'),
    newErrors,
    validateAll,
    1900,
    year,
    questionID,
    '^([1-9][0-9]{0,3})$',
    getMessage
      ? `${caption} : ${
          questions.FirstYearOfServiceWatch?.question ||
          getMessage('labelText.FirstYearOfService')
        } - ${getMessage('error.fill.in.missing.information')}`
      : ''
  );

  // value Watch
  newErrors = ValidateNumeric(
    getValue(questions.valueWatch),
    buildElementId(id, 'VALUABLE_VALUEWATCH'),
    newErrors,
    validateAll,
    1,
    999999,
    questionID,
    '^[1-9]\\d*(?:\\.\\d{1,2})?$',
    getMessage
      ? `${caption} : ${
          questions.valueWatch?.question ||
          getMessage('labelText.valueWatch')
        } - ${getMessage('error.fill.in.missing.information')}`
      : ''
  );
  return dataFormater(newErrors);
};

const makeValubleTypeJewellery = (
  newErrors,
  id,
  questions,
  validateAll,
  questionID,
  caption,
  getMessage
) => {
   //Serial number
   newErrors = ValidateRegExp({
    value: getValue(questions.valuableWhichJewellery),
    id: buildElementId(id, 'VALUABLE_WHICH_JEWELLERY'),
    newErrors,
    validateAll,
    length: 1,
    questionID,
    regExp:
      '^([0-9a-zA-Z\u00C0-\u017F]+([ |-][0-9a-zA-Z\u00C0-\u017F]+)*|)$',
    maxLimit: 100,
    isOptional: false,
    errorLabel: buildMessage(caption, questions, getMessage, 'valuableWhichJewellery', 'labelText.whichJewellery', 'error.fill.in.missing.information')
  });
  newErrors = ValidateNumeric(
    getValue(questions.FirstYearOfServiceJewellery),
    buildElementId(id, 'VALUABLE_FIRSTYEAROFSERVICEJEWELLERY'),
    newErrors,
    validateAll,
    1900,
    year,
    questionID,
    '^([1-9][0-9]{0,3})$',
    getMessage
      ? `${caption} : ${
          questions.FirstYearOfServiceJewellery?.question ||
          getMessage('labelText.FirstYearOfService')
        } - ${getMessage('error.fill.in.missing.information')}`
      : ''
  );

  // value Jewellery
  newErrors = ValidateNumeric(
    getValue(questions.valueJewellery),
    buildElementId(id, 'VALUABLE_VALUEJEWELLERY'),
    newErrors,
    validateAll,
    1,
    999999,
    questionID,
    '^[1-9]\\d*(?:\\.\\d{1,2})?$',
    getMessage
      ? `${caption} : ${
          questions.valueJewellery?.question ||
          getMessage('labelText.valueJewellery')
        } - ${getMessage('error.fill.in.missing.information')}`
      : ''
  );
  return dataFormater(newErrors);
};

const validateValuablesQuestions = (
  id,
  questions,
  validateAll,
  questionID,
  errors,
  caption,
  getMessage
) => {
  let newErrors = { add: [], remove: [] };
  const valuableType = questions.valuableType || { value: 'choose' };

  // Mandatory, validate always type
  newErrors = ValidateSelector(
    valuableType.value,
    buildElementId(id, 'VALUABLE_TYPE'),
    newErrors,
    validateAll,
    questionID,
    getMessage
      ? `${caption} : ${
        valuableType.question || getMessage('labelText.valuableType')
        } - ${getMessage('error.fill.in.missing.information')}`
      : ''
  );

  if (validateAll === true && valuableType.value === 'choose') {
    newErrors.remove = [
      ...newErrors.remove,
      ...errors
        .filter(
          (record) =>
            record.id.indexOf(id) !== -1 && record.id !== id + '_VALUABLE_TYPE'
        )
        .map((record) => record.id),
    ];
  }
if (validateAll === true && valuableType.value !== 'choose' && valuableType.value !== 'Weapon' && valuableType.value !== 'Jewellery') {
// valuableMake
  newErrors = ValidateRegExp({
    value: getValue(questions.valuableMake),
    id: buildElementId(id, 'VALUABLE_MAKE'),
    newErrors,
    validateAll,
    length: 1,
    questionID,
    regExp:
      '^([0-9a-zA-Z\u00C0-\u017F]+([ |-][0-9a-zA-Z\u00C0-\u017F]+)*|)$',
    maxLimit: 100,
    isOptional: false,
    errorLabel: buildMessage(caption, questions, getMessage, 'valuableMake', 'labelText.make', 'error.fill.in.missing.information')
  });
  
  // valuableModel
  newErrors = ValidateRegExp({
    value: getValue(questions.valuableModel),
    id: buildElementId(id, 'VALUABLE_MODEL'),
    newErrors,
    validateAll,
    length: 1,
    questionID,
    regExp:
    '^([0-9a-zA-Z\u00C0-\u017F]+([ |-][0-9a-zA-Z\u00C0-\u017F]+)*|)$',
    maxLimit: 100,
    isOptional: false,
    errorLabel: buildMessage(caption, questions, getMessage, 'valuableModel', 'labelText.model', 'error.fill.in.missing.information')
  });
}

if (validateAll === true && valuableType.value !== 'choose' && (valuableType.value === 'Camera and accessories' || valuableType.value === 'Lens')) {
  // valuableDeviceNumber
    newErrors = ValidateRegExp({
      value: getValue(questions.valuableDeviceNumber),
      id: buildElementId(id, 'VALUABLE_DEVICE_NUMBER'),
      newErrors,
      validateAll,
      length: 1,
      questionID,
      regExp:
        '^([0-9a-zA-Z\u00C0-\u017F]+([ |-][0-9a-zA-Z\u00C0-\u017F]+)*|)$',
      maxLimit: 100,
      isOptional: false,
      errorLabel: buildMessage(caption, questions, getMessage, 'valuableDeviceNumber', 'labelText.deviceNumber', 'error.fill.in.missing.information')
    });
  }

  switch (valuableType.value) {
    case 'Musical':
      return makeValubleTypeMusical(
        newErrors,
        id,
        questions,
        validateAll,
        questionID,
        caption,
        getMessage
      );
    case 'Camera and accessories':
      return makeValubleTypeCamera(
        newErrors,
        id,
        questions,
        validateAll,
        questionID,
        caption,
        getMessage
      );
    case 'Lens':
      return makeValubleTypeLens(
        newErrors,
        id,
        questions,
        validateAll,
        questionID,
        caption,
        getMessage
      );
    case 'Weapon':
      return makeValubleTypeWeapon(
        newErrors,
        id,
        questions,
        validateAll,
        questionID,
        caption,
        getMessage
      );
    case 'Watch':
      return makeValubleTypeWatch(
        newErrors,
        id,
        questions,
        validateAll,
        questionID,
        caption,
        getMessage
      );
    case 'Jewellery':
      return makeValubleTypeJewellery(
        newErrors,
        id,
        questions,
        validateAll,
        questionID,
        caption,
        getMessage
      );
    default:
      return dataFormater(newErrors);
  }
};

export default validateValuablesQuestions;
